import React from "react";
import {ModalInfoContent, ModalInfoContentBottom} from "../../../../components/ui/Content";
import {Body1, ModalInfoDiscription} from "../../../../components/Font";
import {useTheme} from "styled-components";
import {useAppSelector} from "../../../../app/hooks";
import {InfoModal} from "../../../../ui/Modal/InfoModal";

export interface PersonalInfoProps {
    onGoEdit(): void

    onGoBack(): void
}

export const PersonalInfo = ({onGoEdit, onGoBack}: PersonalInfoProps) => {
    const Theme = useTheme()
    const {personalInfo} = useAppSelector(state => state.account)

    const content = () => {
        return <>
            <ModalInfoContent>
                <ModalInfoDiscription color={Theme.color.secondary}>
                    Фамилия
                </ModalInfoDiscription>
                <Body1>
                    {personalInfo.surname || '—'}
                </Body1>
            </ModalInfoContent>

            <ModalInfoContent>
                <ModalInfoDiscription color={Theme.color.secondary}>
                    Имя
                </ModalInfoDiscription>
                <Body1>
                    {personalInfo.name || '—'}
                </Body1>
            </ModalInfoContent>


            <ModalInfoContent>
                <ModalInfoDiscription color={Theme.color.secondary}>
                    Отчество
                </ModalInfoDiscription>
                <Body1>
                    {personalInfo.patronymic || '—'}
                </Body1>
            </ModalInfoContent>


            <ModalInfoContent>
                <ModalInfoDiscription color={Theme.color.secondary}>
                    Дата рождения
                </ModalInfoDiscription>
                <Body1>
                    {personalInfo.birthdate?.format('LL') || '—'}
                </Body1>
            </ModalInfoContent>

            <ModalInfoContentBottom>
                <ModalInfoDiscription color={Theme.color.secondary}>
                    Пол
                </ModalInfoDiscription>
                <Body1>
                    {personalInfo.sex?.name || '—'}
                </Body1>
            </ModalInfoContentBottom>
        </>
    }
    return <InfoModal
        title={'Персональная информация'}
        content={content}
        onEdit={onGoEdit}
        onGoBack={onGoBack}
    />
}
